// generated by the plop

import { PaginateQuery, PaginatorModel } from 'symbols';

import { OrderFilterModel, OrderModel, OrdersCountModel, OrderStatusExpectBackend } from '../../symbols';

export class GetOrderListInteractive {
  static type = '[orderList] GetOrderListInteractive';

  constructor(public filter: PaginateQuery<OrderFilterModel>) {
  }
}

export class UpdatedOrderByWS {
  static type = '[orderList] UpdatedOrderByWS';

  constructor(public order: OrderModel) {
  }
}

export class CreatedOrderByWS {
  static type = '[orderList] CreatedOrderByWS';

  constructor(public order: OrderModel) {
  }
}

export class GetOrderList {
  static type = '[orderList] GetOrderList';

  constructor(public lazy: boolean, public filter?: PaginateQuery<OrderFilterModel>) {
  }
}

export class GetOrderListSuccess {
  static type = '[orderList] GetOrderListSuccess';

  constructor(public orderList: PaginatorModel<OrderModel>, public lazy: boolean) {
  }
}

export class GetOrderListError {
  static type = '[orderList] GetOrderListError';

  constructor(public error: any) {
  }
}

export class GetOrderStatusList {
  static type = '[orderList] GetOrderStatusList';

  constructor() {
  }
}

export class GetOrderStatusListSuccess {
  static type = '[orderList] GetOrderStatusListSuccess';

  constructor(public orderStatusList: OrderStatusExpectBackend[]) {
  }
}

export class GetOrderStatusListError {
  static type = '[orderList] GetOrderStatusListError';

  constructor(public error: any) {
  }
}

export class ClearScrollPositionOrderList {
  static type = '[OrdersList] ClearScrollPositionOrderList';
}

export class UpdateScrollPositionOrderList {
  static type = '[OrdersList] UpdateScrollPositionOrderList';

  constructor(public position: number) {
  }
}

export class SetLastOpenedOrderId {
  static type = '[OrdersList] SetLastOpenedOrderId';

  constructor(public orderId: string) {
  }
}


export class GetOrdersCount {
  static type = '[OrdersList] GetOrdersCount';
}

export class OrdersCountWs {
  static type = '[OrdersList] OrdersCountWS';

  constructor(public ordersCount: OrdersCountModel) {
  }
}

export class AcceptedCountWS {
  static type = '[OrdersList] AcceptedCountWS';

  constructor(public ordersCount: number) {
  }
}

export class OrdersAcceptedCountWS {
  static type = '[OrdersList] OrdersAcceptedCountWS';

  constructor(public acceptedCount: number) {
  }
}
